import React from "react";

// Instagram
export const InstagramIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    aria-hidden="true"
    fill="currentColor"
    {...props}
  >
    <path d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.9.2 2.4.4.6.2 1 .5 1.5 1 .5.5.8.9 1 1.5.2.5.3 1.2.4 2.4.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.2 1.9-.4 2.4-.2.6-.5 1-.9 1.5-.5.5-.9.8-1.5 1-.5.2-1.2.3-2.4.4-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.9-.2-2.4-.4-.6-.2-1-.5-1.5-1a3.6 3.6 0 0 1-1-1.5c-.2-.5-.3-1.2-.4-2.4C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.2-1.9.4-2.4.2-.6.5-1 .9-1.5.5-.5.9-.8 1.5-1 .5-.2 1.2-.3 2.4-.4C8.4 2.2 8.8 2.2 12 2.2Zm0 1.8c-3.2 0-3.6 0-4.9.1-1 0-1.5.2-1.8.3-.5.2-.8.4-1.1.7-.3.3-.5.6-.7 1.1-.1.3-.3.8-.3 1.8-.1 1.3-.1 1.7-.1 4.9s0 3.6.1 4.9c0 1 .2 1.5.3 1.8.2.5.4.8.7 1.1.3.3.6.5 1.1.7.3.1.8.3 1.8.3 1.3.1 1.7.1 4.9.1s3.6 0 4.9-.1c1 0 1.5-.2 1.8-.3.5-.2.8-.4 1.1-.7.3-.3.5-.6.7-1.1.1-.3.3-.8.3-1.8.1-1.3.1-1.7.1-4.9s0-3.6-.1-4.9c0-1-.2-1.5-.3-1.8-.2-.5-.4-.8-.7-1.1a2.7 2.7 0 0 0-1.1-.7c-.3-.1-.8-.3-1.8-.3-1.3-.1-1.7-.1-4.9-.1Zm0 3.4a6.6 6.6 0 1 1 0 13.2 6.6 6.6 0 0 1 0-13.2Zm0 2a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2Zm6.9-2.2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z" />
  </svg>
);

// Facebook
export const FacebookIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    aria-hidden="true"
    fill="currentColor"
    {...props}
  >
    <path d="M22 12.07C22 6.5 17.52 2 12 2S2 6.5 2 12.07C2 17.1 5.66 21.3 10.44 22v-7.02H7.9v-2.9h2.55V9.41c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.23.2 2.23.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.86h2.78l-.44 2.9h-2.34V22C18.34 21.3 22 17.1 22 12.07Z" />
  </svg>
);

// LinkedIn
export const LinkedinIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    aria-hidden="true"
    fill="currentColor"
    {...props}
  >
    <path d="M20.45 20.45h-3.55v-5.3c0-1.26-.02-2.88-1.75-2.88-1.75 0-2.02 1.37-2.02 2.78v5.4H9.58V9h3.4v1.56h.05c.47-.9 1.63-1.85 3.36-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28ZM5.34 7.44a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12ZM3.56 20.45h3.55V9H3.56v11.45Z" />
  </svg>
);

// WhatsApp
export const WhatsappIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    aria-hidden="true"
    fill="currentColor"
    {...props}
  >
    <path d="M20 3.9A10 10 0 0 0 3.6 17.9L3 22l4.2-1.1a10 10 0 0 0 15.6-7.5c.2-2.7-.8-5.3-2.8-7.3ZM12 20.2c-1.7 0-3.3-.5-4.7-1.4l-.3-.2-2.8.7.7-2.7-.2-.3a8 8 0 1 1 7.3 4Zm4.6-5.9c-.3-.1-1.7-.9-1.9-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.1-.2.2-.3.2-.6.1-1.7-.8-3-2.2-3.4-2.8-.2-.3 0-.5.1-.6l.3-.3.1-.2c.1-.2.1-.3 0-.5l-1-2.4c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.7.3-.7.6-1 1.5-1 2.4 0 1.4 1 2.7 2.2 3.8 1.2 1.3 3 2.2 4.6 2.7.5.2 1 .2 1.4.1.5-.1 1.7-.8 1.9-1.4.2-.4.2-.8.1-1Z" />
  </svg>
);
